export default {
    track() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src =
            'https://ct.capterra.com/capterra_tracker.js?vid=2103439&vkey=1964159804ae9121c7bceba06a349a47';

        document.body.appendChild(script);
    }
};
